export default __webpack_public_path__ + "locales/ja-JP/InfoPanel.json?hash=63a4ed6c104ab926439a2adbbf8c3829";